import html2canvas from "html2canvas";
import { saveAs } from 'file-saver';
import { thousandNumberFormat } from '../../Common/Helpers';
import { authHeader } from "../../../javascript/auth-header";
import { getVintageFromReportType } from '../../Common/Helpers'

async function saveFactSheetImage(div, index, fileName, controller, state, props) {
    var element = document.getElementsByClassName(div)[index];
    var currentDateTime = state.currentDateTime;
    var display_id = props.UserState.report_display_id;
    var vintage = getVintageFromReportType("factsheet" + (props.match.params["factSheetType"] == undefined ? "" : props.match.params["factSheetType"]), props.UserState);
    await html2canvas(element as HTMLCanvasElement).then(function (canvas) {
        canvas.toBlob(function (blob) {
            let url = "/IRISReportsMicroservice/api/PDF/FactSheetPDF/send_image/";
            let form = new FormData();

            form.append('image', blob, fileName);
            form.append("display_id", display_id);
            form.append("vintage", vintage);
            form.append("currentDateTime", currentDateTime);
            form.append("factSheetType", props.match.params["factSheetType"])
            var headers = authHeader();
            fetch(url, { method: 'POST', body: form, headers: headers })
        });
    });
}

function saveFactSheetPDF(controller, state, props) {
    var currentDateTime = state.currentDateTime;
    var display_id = props.UserState.report_display_id;
    //var university = props.UserState.university;
    var vintage = getVintageFromReportType("factsheet" + (props.match.params["factSheetType"] == undefined ? "" : props.match.params["factSheetType"]), props.UserState);
    let url = "/IRISReportsMicroservice/api/PDF/FactSheetPDF/generate_pdf";
    //let url = "/webapi/" + controller + "/generate_pdf/";

    var obj = {};
    const { university, description, employment_text, employment_bullets, top_heading,
        list_agencies, spending_heading, statelegislative_heading1, statelegislative_heading2,
        statename, total_students, homestate_info, stayed_bullet,
        start_year, current_year, release_date } = props.FactSheetState;
    obj["display_id"] = display_id;
    obj["currentDateTime"] = currentDateTime;
    obj["vintage"] = vintage;
    obj["university"] = university;
    obj["university_list_text"] = (university == "CPUPC Universities" || university == "CPUPC/IRIS Universities") ?
        "The universities included in this report, which are members of the Council of Public University Presidents and Chancellors and IRIS, are: " + description
        : (university == "IRIS Universities") ? "The universities included in this report, which are members of IRIS, are: " + description : "";

    obj["employment_text"] = employment_text;
    obj["employment_bullets"] = employment_bullets;
    obj["top_heading"] = top_heading;
    obj["list_agencies"] = list_agencies;
    obj["spending_heading"] = spending_heading;
    obj["statelegislative_heading1"] = statelegislative_heading1;
    obj["statelegislative_heading2"] = statelegislative_heading2;
    obj["statename"] = statename;
    obj["total_students"] = total_students;
    obj["pct_staying_in_homestate"] = homestate_info.pct_staying_in_homestate;
    
    obj["stayed_bullet"] = stayed_bullet;
    obj["release_date"] = release_date;

    if (props.match.params["factSheetType"] == "stateLegislative") {
        obj["legislativeLowerTable"] = props.FactSheetState.legislativeLowerTable;
        obj["legislativeUpperTable"] = props.FactSheetState.legislativeUpperTable;
    }
    else {
        obj["spending_congress"] = props.FactSheetState.spending_congress;
    }
    
    obj["start_year"] = start_year;
    obj["current_year"] = current_year;

    obj["spending_congress_total"] = props.FactSheetState.spending_congress_total;
    obj["spending_congress_total_range"] = props.FactSheetState.spending_congress_total_range;

    obj["factSheetType"] = props.match.params["factSheetType"];//'stateLegislative'

    var headers = authHeader();
    headers.append('Accept', 'application/json'); // This one is enough for GET requests
    headers.append('Content-Type', 'application/json'); // This one sends body

    fetch(url, { method: 'POST', body: JSON.stringify(obj), headers: headers })
        .then(res => {
            return res.blob();
        })
        .then(blob => {
            if (props.match.params["factSheetType"] == 'stateLegislative')
                saveAs(blob, 'IRIS_StateLegislative_FactSheet_' + currentDateTime + '.pdf');
            else
                saveAs(blob, 'IRIS_CongressionalDistrict_FactSheet_' + currentDateTime + '.pdf');
            // log PDF download in triggered events
            props.addTriggeredEvent(`${props.match.params["factSheetType"] == 'stateLegislative' ? "State Legislative" : "Congressional District"} Fact Sheet`, props.UserState.username, props.UserState.display_id, "downloaded report PDF")
        }).catch((error) => {
            console.log(error);
        })
}

export async function downloadFactSheetPDF(state, props) {
    if (props.match.params["factSheetType"] != "stateLegislative") {

        await saveFactSheetImage("congressmap_div", 0, "chart1.png", "FactSheet", state, props);

        await saveFactSheetImage("congressmap_div", 1, "chart2.png", "FactSheet", state, props);

        saveFactSheetPDF("FactSheet", state, props);
    }
    else
        saveFactSheetPDF("FactSheet", state, props);
}